import { useEffect } from "react";
import "./App.css";

import {
  SectionHero,
  SectionTrilogy,
  SectionGaleri,
  SectionSponsors,
} from "@mmfestival/shared-components";

const Beranda = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <SectionHero />
      <SectionTrilogy />
      {/*  <SectionGaleri /> */}
      {/* <SectionSponsors /> */}
      {/* Sembunyikan section sponsor sesuai request user */}
    </div>
  );
};

export default Beranda;
